import { render, staticRenderFns } from "./BookingChooseCustomer.vue?vue&type=template&id=647e6ef0&scoped=true"
import script from "./BookingChooseCustomer.vue?vue&type=script&lang=js"
export * from "./BookingChooseCustomer.vue?vue&type=script&lang=js"
import style0 from "./BookingChooseCustomer.vue?vue&type=style&index=0&id=647e6ef0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647e6ef0",
  null
  
)

export default component.exports